import React from "react";
import { Home, RefreshCcw, SkipBack } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "reactstrap";
import { withRouter } from "react-router";

const Breadcrumb = ({ children, onBackButton, backButton, history, location, title, currentLevel, parent, onRefreshClick, pageHeaderTheme }) => {
  const handleBackButton = () => {
    if (location.state && location.state.from) {
      history.push(location.state.from);
    } else {
      history.goBack();
    }
  };

  return (
    <>
      <div className="container-fluid" style={{ fontFamily: "Nunito" }}>
        <div className="page-header" style={pageHeaderTheme}>
          <div className="row">
            <div className="col-8">
              <div className="page-header-left">
                {backButton && (
                  <Button size="xs" color="link" className="mr-3" onClick={onBackButton || handleBackButton}>
                    <SkipBack size="24" color="#f0292a" />
                  </Button>
                )}
                {onRefreshClick && (
                  <Button size="xs" color="link" className="mr-3" onClick={onRefreshClick}>
                    <RefreshCcw size="24" color="#f0292a" />
                  </Button>
                )}
                <h3
                  style={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {title}
                </h3>
                <ol className="breadcrumb pull-right">
                  <li className="breadcrumb-item">
                    <Link to={`${process.env.PUBLIC_URL}/dashboard/default`} key={title}>
                      <Home color="#f0292a" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">{parent}</li>
                  {currentLevel === "none" ? null : (
                    <li
                      className="breadcrumb-item"
                      style={{
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {currentLevel || title}
                    </li>
                  )}
                </ol>
              </div>
            </div>
            {React.Children.map(children, (child) => (
              <div className="col-12 d-flex justify-content-end">{child}</div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default withRouter(Breadcrumb);
